export const CHAMELEON_INIT_TOKEN = 'S2zZSQHFqRiaKIyz79tBq7cJsyUHkmGrWcV78v94PUeiDX-1CWe8G-zMvYGOI5YlPVx4h0'
